import CompanyStatus, {
  CompanyStatusFormSend,
  UpdateCompanyStatusFormSend,
} from "@/interfaces/CompanyStatus";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import api from "../api";

export const companyStatuses = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyStatuses: build.query<IPaginateResponse<CompanyStatus>, IFilters>(
      {
        query: (params) => ({
          url: `/company-statuses`,
          params,
        }),
        providesTags: (result, _error, _arg) =>
          result
            ? [
                ...result.data.map(({ id }) => ({
                  type: "CompanyStatuses" as const,
                  id,
                })),
                { type: "CompanyStatuses", id: "LIST" },
              ]
            : [{ type: "CompanyStatuses", id: "LIST" }],
      }
    ),
    deleteCompanyStatus: build.mutation<void, string>({
      query: (id) => ({
        url: `/company-statuses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "CompanyStatuses", id: "LIST" }],
    }),
    storeCompanyStatus: build.mutation<CompanyStatus, CompanyStatusFormSend>({
      query: (data) => ({
        url: `/company-statuses`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "CompanyStatuses", id: "LIST" }],
    }),
    updateCompanyStatus: build.mutation<
      CompanyStatus,
      [string, UpdateCompanyStatusFormSend]
    >({
      query: ([id, body]) => ({
        url: `/company-statuses/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_, __, [id]) => [{ type: "CompanyStatuses", id }],
    }),
    getCompanyStatus: build.query<CompanyStatus, string>({
      query: (id) => `/company-statuses/${id}`,
      providesTags: (result, _error, id) => [{ type: "CompanyStatuses", id }],
    }),
  }),

  overrideExisting: true,
});

export const {
  useLazyGetCompanyStatusesQuery,
  useGetCompanyStatusesQuery,
  useDeleteCompanyStatusMutation,
  useStoreCompanyStatusMutation,
  useUpdateCompanyStatusMutation,
  useGetCompanyStatusQuery,
} = companyStatuses;
